/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_USER_URL, COMMON_HEADER_CONFIG} from "src/config";

class RoleService {
  getAccessToken = () => localStorage.getItem("accessToken");

  searchRoles = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_USER_URL}/roles`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          size: 100,
          page: 1,
          ...data
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getRoles = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_USER_URL}/roles`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          size: 100,
          page: 1
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOneRole = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_USER_URL}/role/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createRole = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_USER_URL}/role`,
        data,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateRole = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = JSON.stringify({
        ...data,
        active: true,
        platform_code: "centralweb"
      });
      const config = {
        method: "put",
        url: `${API_USER_URL}/role/${data.id}`,
        data: dataUpdate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updatePermissionOfRole = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_USER_URL}/role/permissions`,
        data: dataUpdate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateActiveRole = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = JSON.stringify({
        ...data,
        active: !data.active
      });
      const config = {
        method: "put",
        url: `${API_USER_URL}/role/${data.id}`,
        data: dataUpdate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteRole = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_USER_URL}/role/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const roleService = new RoleService();

export default roleService;
